
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { ReactElement } from 'react'
import { useTags } from '@jconradi/tutu-porn-components/hooks/useTags'
import { Spinner } from '@jconradi/tutu-porn-components/components/Spinner/Spinner'
import { RoundedLinkButton } from '@jconradi/tutu-porn-components/components/Buttons/LinkButton'
import { PageTitle } from '@jconradi/tutu-porn-components/components/Text/PageTitle'
import { dehydrate, QueryClient } from '@tanstack/react-query'
import { getTags } from '@jconradi/tutu-porn-api-client/src/tags'
import { BannerAd } from '@jconradi/tutu-porn-components/components/Ads/Exoclick/BannerAd'
import { getLayout } from '../components/Layout/Layout'

export default function Tags() {
    const tags = useTags();

    return (
        <section className='flex flex-col'>
            <PageTitle>Most Popular Tags</PageTitle>
            {tags.isLoading && <Spinner className="mx-auto" />}
            <div className="flex flex-row flex-wrap gap-[8px] justify-center max-h-[calc(336px+4rem)] overflow-hidden">
                {tags.data?.slice(0, 100).map((tag: any) => {
                    return (
                        <RoundedLinkButton key={tag.name} tag={tag.name} className='px-[16px] py-[4px] text-base leading-[24px]'>
                            <p className='font-thin text-sm leading-[10px]'>{`${tag.mediaCount} Uploads`}</p>
                        </RoundedLinkButton>
                    )
                })
                }
            </div>
        </section>
    )
}

Tags.getLayout = (page: ReactElement) => getLayout(page)

 async function _getStaticProps() {
    const queryClient = new QueryClient();
  
    await queryClient.prefetchQuery(['tags'], async () => {
        const tags = await getTags();

        return tags.data;
    })
  
    return {
      props: {
        dehydratedState: dehydrate(queryClient),
      },
      revalidate: 60 * 5
    }
  }

// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/tags',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  